import { styled } from "@mui/material/styles";

export const Container = styled("div")(({ theme }) => ({
  "& .dashboard-content": {
    display: "flex",
    gap: "32px",
    [theme.breakpoints.down("lg")]: {
      flexDirection: "column",
    },
    "& .main-content": {
      flex: "0 0 calc(70% - 16px)",
    },
    "& .sidebar": {
      flex: "0 0 calc(30% - 16px)",
      "& .sidebar-widget": {
        border: "#211F45 1px solid",
        borderRadius: "8px",
        padding: "20px",
        marginBottom: "2rem",
        boxShadow:
          "0px 12px 16px -4px rgba(0, 91, 140, 0.10),0px 4px 6px -2px rgba(0, 91, 140, 0.03),0px 2px 2px -1px rgba(0, 91, 140, 0.04)",
        "&:last-child": {
          marginBottom: 0,
        },
        "& .dash-loader": {
          marginBottom: "0"
        },
        "& > p": {
          color: "#D5D7DA",
          fontSize: "12px",
          margin: "0 0 15px 0",
        },
        "& .widget-icon": {
          display: "flex",
          alignItems: "center",
          gap: "5px",
          marginBottom: "10px",
          "& span": {
            color: "#01ECFF",
            textTransform: "uppercase",
            fontSize: "12px",
          },
        },
        "& .widget-cta-btn": {
          width: "100%",
          "& p": {
            display: "flex",
            alignItems: "center",
            gap: "5px",
          },
        },
        "& .widget-title": {
          display: "flex",
          alignItems: "center",
          justifyContent: "space-between",
          marginBottom: "16px",
          "& h2": {
            margin: "0",
            fontWeight: "600",
            fontSize: "18px",
          },
          "& .view-all": {
            color: "#7C6FCD",
            fontWeight: "500",
            fontSize: "14px",
            display: "flex",
            alignItems: "center",
            gap: "4px",
            cursor: "pointer",
            textDecoration: "none",
            "&:hover": { opacity: 0.8 },
          },
        },
        "& > ul": {
          listStyle: "none",
          margin: "0",
          padding: "0",
          display: "flex",
          flexDirection: "column",
          gap: "12px",
          "& > li": {
            display: "flex",
            alignItems: "center",
            gap: "12px",
            padding: "12px",
            border: "1px solid #211F45",
            borderRadius: "8px",
            cursor: "pointer",
            transition: "background 0.2s ease",
            "&:hover": { background: "#1C1A42" },
            "& .tip-icon": {
              width: "32px",
              height: "32px",
              minWidth: "32px",
              background: "#1C1A42",
              border: "1px solid #2E2B5E",
              borderRadius: "8px",
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              color: "#7C6FCD",
              fontSize: "18px",
            },
            "& .tip-info": {
              flex: 1,
              "& .tip-title": {
                color: "#fff",
                fontWeight: "600",
                fontSize: "14px",
                marginBottom: "2px",
              },
              "& .tip-subtitle": {
                color: "#6B6A8E",
                fontSize: "12px",
              },
            },
            "& .tip-meta": {
              display: "flex",
              alignItems: "center",
              gap: "8px",
              color: "#6B6A8E",
              fontSize: "13px",
              whiteSpace: "nowrap",
              "& .play-btn": {
                width: "28px",
                height: "28px",
                border: "1px solid #2E2B5E",
                borderRadius: "50%",
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                color: "#fff",
                fontSize: "10px",
              },
            },
          },
        },
        "& .previous-sims": {
          display: "flex",
          flexDirection: "column",
          gap: "12px",
          marginBottom: "20px",
          "& .sim-card": {
            backgroundColor: "#12133a",
            border: "1px solid rgba(255, 255, 255, 0.08)",
            borderRadius: "8px",
            padding: "20px",
            cursor: "pointer",
            transition: "border-color 0.2s",

            "&:hover": {
              borderColor: "rgba(255, 255, 255, 0.18)",
            },
            "& .convo-insights-badge": {
              background: "rgba(1, 236, 255, 0.50)",
              borderRadius: "9999px",
              padding: "2px 8px",
              display: "inline-flex",
              alignItems: "center",
              gap: "5px",
              border: "#00B2D6 1px solid",
              fontSize: "12px",
              [theme.breakpoints.down("md")]: {
                width: "165px",
              },
            },
            "& .sim-card__title": {
              fontSize: "15px",
              fontWeight: "700",
              color: "#ffffff",
              marginBottom: "6px",
              lineHeight: "1.3",
            },

            "& .sim-card__category": {
              fontSize: "13px",
              color: "rgba(255, 255, 255, 0.45)",
              marginBottom: "16px",
              lineHeight: "1.4",
            },

            "& .sim-card__footer": {
              display: "flex",
              alignItems: "center",
              justifyContent: "space-between",
              flexWrap: "wrap",
              gap: "10px",
            },

            "& .sim-card__score": {
              display: "flex",
              alignItems: "center",
              gap: "8px",
              "& .score-label": {
                fontSize: "12px",
                color: "#01ECFF",
                fontWeight: "600",
              },

              "& .score-value": {
                fontSize: "13px",
                color: "#ffffff",
                border: "1px solid #01ECFF",
                borderRadius: "6px",
                padding: "2px 8px",
              },
            },

            "& .sim-card__feedback": {
              display: "flex",
              alignItems: "center",
              gap: "6px",
              fontSize: "13px",
              fontWeight: "500",
              color: "#a78bfa",
              textDecoration: "none",

              "& svg": {
                width: "14px",
                height: "14px",
              },
            },
          },
        },
      },
    },
  },
  "& .dash-loader": {
    display: "flex",
    flexDirection: "column",
    textAlign: "center",
    justifyContent: "center",
    alignItems: "center",
    gap: "10px",
    fontSize: "14px",
    padding: "50px 0",
    border: "#211F45 1px solid",
    borderRadius: "8px",
    marginBottom: "32px",
    "& span": {
      opacity: ".8",
    },
  },
  "& .metric-tiles": {
    display: "grid",
    gridTemplateColumns: "repeat(2, 1fr)",
    marginBottom: "32px",
    gap: "32px",
    textAlign: "center",
    [theme.breakpoints.down("md")]: {
      gap: "16px",
    },
    "@media (min-width:991px)": {
      gridTemplateColumns: `repeat(4, 1fr)`,
    },
    "& .metric-tile": {
      flex: 1, // even width across all tiles
      borderRadius: "8px",
      padding: "12px 24px",
      [theme.breakpoints.down("md")]: {
        padding: "12px",
      },
      "& .icon svg": {
        width: 20,
        height: 20
      },
      "& p": {
        margin: 0,
        fontWeight: "300",
        fontSize: "13px",
        color: "rgba(254, 254, 254, 0.72)",
        [theme.breakpoints.down("md")]: {
          fontSize: "13px",
        },
      },
      "& span": {
        fontSize: "22px",
        fontWeight: "600",
        display: "block",
        margin: "5px 0",
        [theme.breakpoints.down("md")]: {
          fontSize: "18px",
        },
      },
      "& > div": {},
      "&:nth-child(1)": {
        border: "1px solid rgba(255, 181, 71, 0.333)",
        background:
          "radial-gradient(60% 50% at 50% 20%, rgba(255, 181, 71, 0.25) 0%, transparent 70%), radial-gradient(80% 60% at 0% 100%, rgba(150, 46, 255, 0.2) 0%, transparent 60%), radial-gradient(80% 60% at 100% 100%, rgba(255, 181, 71, 0.15) 0%, transparent 60%)",
      },
      "&:nth-child(2)": {
        border: "1px solid rgba(168, 126, 255, 0.333)",
        background:
          "radial-gradient(60% 50% at 50% 20%, rgba(168, 126, 255, 0.25) 0%, transparent 70%), radial-gradient(80% 60% at 0% 100%, rgba(150, 46, 255, 0.2) 0%, transparent 60%), radial-gradient(80% 60% at 100% 100%, rgba(168, 126, 255, 0.15) 0%, transparent 60%)",
      },
      "&:nth-child(3)": {
        border: "1px solid rgba(91, 228, 155, 0.333)",
        background:
          "radial-gradient(60% 50% at 50% 20%, rgba(91, 228, 155, 0.25) 0%, transparent 70%), radial-gradient(80% 60% at 0% 100%, rgba(150, 46, 255, 0.2) 0%, transparent 60%), radial-gradient(80% 60% at 100% 100%, rgba(91, 228, 155, 0.15) 0%, transparent 60%)",
      },
      "&:nth-child(4)": {
        border: "1px solid rgba(1, 236, 255, 0.333)",
        background:
          "radial-gradient(60% 50% at 50% 20%, rgba(1, 236, 255, 0.25) 0%, transparent 70%), radial-gradient(80% 60% at 0% 100%, rgba(150, 46, 255, 0.2) 0%, transparent 60%), radial-gradient(80% 60% at 100% 100%, rgba(1, 236, 255, 0.15) 0%, transparent 60%)",
      },
    },
  },
  "& .dashboard-special-widget": {
    marginBottom: "32px",
    border: "#211F45 1px solid",
    background: "rgba(255,255,255,0.04)",
    boxShadow:
      "0px 12px 16px -4px rgba(0, 91, 140, 0.10),0px 4px 6px -2px rgba(0, 91, 140, 0.03),0px 2px 2px -1px rgba(0, 91, 140, 0.04)",
    borderRadius: "12px",
    padding: "24px",
    boxSizing: "border-box",
    "& *, & *::before, & *::after": {
      boxSizing: "border-box",
    },
    [theme.breakpoints.down("md")]: {
      padding: "16px",
    },

    "& .widget-title": {
      display: "flex",
      justifyContent: "space-between",
      alignItems: "center",
      marginBottom: "15px",
      [theme.breakpoints.down("md")]: {
        flexDirection: "column",
        alignItems: "flex-start",
        gap: "8px",
        "& .heading": { order: 2 },
        "& .badge-new": { order: 1, marginBottom: "10px" },
      },
      "& .heading": {
        display: "flex",
        alignItems: "center",
        gap: "15px",
        "& .icon": {
          background:
            "linear-gradient(0deg, rgba(150, 46, 255, 0.05) 0%, rgba(150, 46, 255, 0.05) 100%), var(--Component-colors-Utility-Brand-utility-brand-600, #211F45)",
          borderRadius: "8px",
          padding: "6.5px",
          width: "32px",
          height: "32px",
          border: "1px solid #2E2B5E",
        },
        "& h2": {
          margin: 0,
          fontWeight: "600",
          fontSize: "clamp(0.75rem, 0.75rem + 2vw, 1.2rem)",
        },
      },
      "& .badge-new": {
        borderRadius: "9999px",
        border: "1px solid #A87EFF",
        background: "#D1C7FF",
        padding: "2px 8px",
        fontWeight: "600",
        textTransform: "uppercase",
        fontSize: "12px",
        color: "#02002B",
        display: "inline-flex",
        gap: "2px",
        alignItems: "center",
      },
    },
    "& .widget-description": {
      margin: " 0 0 15px 0",
      fontWeight: "400",
      fontSize: "14px",
      color: "#eaeaea",
    },
    "&.ci": {
      "& .form-container": {
        position: "relative",
        "& .dropzone": {
          margin: "20px 0",
          border: "1px dashed rgba(254, 254, 254, 0.25)",
        },
        "& .progress-container": {
          marginBottom: "20px",
        },
        "& .inline-fields": {
          display: "grid",
          gridTemplateColumns: "repeat(1, 1fr)",
          alignItems: "center",
          gap: "20px",
          "@media (min-width:991px)": {
            gridTemplateColumns: `repeat(2, 1fr)`,
          },
          "& > *": {
            minWidth: 0,
          },
          "& label": {
            marginBottom: "8px",
            display: "inline-block",
            fontSize: "14px",
          },
          "& .custom-select-wrapper": {
            "& .custom-select-trigger": {
              padding: "13px!important",
            },
          },
          "& .input-field": {
            [theme.breakpoints.down("md")]: {
              margin: "0 !important",
            },
          },
        },
        "&.uploading form": {
          opacity: ".3",
        },
        "& .uploading-loading": {
          position: "absolute",
          zIndex: "99",
          width: "100%",
          height: "100%",
          // background: "rgba(255,255,255,.2)",
          justifyContent: "center",
          display: "flex",
          alignItems: "center",
          gap: "10px",
        },
        "& .input-field": {
          color: "#D1C7FF",

          "& .help-text": {
            color: "#ccc",
            fontSize: "13px",
            fontStyle: "italic",
          },
        },
        "& .actions": {
          "& button": {
            border: "#962EFF 1px solid",
            background: "#030039",
            width: "100%",
            padding: "15px",
            "& p": {
              color: "#fff",
              display: "inline-flex",
              alignItems: "center",
              gap: "5px",
            },
            "&:hover": {
              background: "#962EFF",
            },
          },
        },
      },
    },
  },
}));
